import React from 'react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { Music, Youtube, ExternalLink } from 'lucide-react';

const YOUTUBE_PLAYLISTS = [
    { id: 'lofi', name: 'Lo-Fi Beats', query: 'lofi hip hop radio', color: 'bg-purple-500/20' },
    { id: 'ambient', name: 'Ambient Music', query: 'ambient relaxing music', color: 'bg-blue-500/20' },
    { id: 'nature', name: 'Nature Sounds', query: 'nature sounds relaxation', color: 'bg-green-500/20' },
    { id: 'meditation', name: 'Meditation', query: 'meditation music calm', color: 'bg-teal-500/20' },
    { id: 'classical', name: 'Classical Piano', query: 'classical piano relaxing', color: 'bg-amber-500/20' },
    { id: 'jazz', name: 'Smooth Jazz', query: 'smooth jazz relaxing', color: 'bg-orange-500/20' }
];

const MusicPlayer = () => {
    const openYoutube = (query) => {
        window.open(`https://www.youtube.com/results?search_query=${encodeURIComponent(query)}`, '_blank');
    };

    return (
        <Card className="glass-card" data-testid="music-player">
            <CardContent className="p-4">
                <div className="flex items-center gap-2 mb-4">
                    <Music className="w-5 h-5 text-primary" />
                    <span className="font-medium">Background Music</span>
                </div>

                <p className="text-sm text-muted-foreground mb-4">
                    Open relaxing playlists on YouTube to accompany your journaling:
                </p>
                
                <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
                    {YOUTUBE_PLAYLISTS.map((playlist) => (
                        <Button
                            key={playlist.id}
                            variant="outline"
                            onClick={() => openYoutube(playlist.query)}
                            className={`rounded-xl justify-start text-sm h-auto py-3 ${playlist.color} border-0 hover:opacity-80`}
                            data-testid={`youtube-${playlist.id}`}
                        >
                            <Youtube className="w-4 h-4 mr-2 text-red-500 flex-shrink-0" />
                            <span className="truncate">{playlist.name}</span>
                            <ExternalLink className="w-3 h-3 ml-auto flex-shrink-0 opacity-50" />
                        </Button>
                    ))}
                </div>

                <p className="text-xs text-muted-foreground mt-4 text-center">
                    Opens in a new tab on YouTube
                </p>
            </CardContent>
        </Card>
    );
};

export default MusicPlayer;
